<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Setup Exam
    </button>
    <a-modal
      v-model="visible"
      title="Setup a new exam"
      :width="1300"
      style="top: 20px"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :disabled="form.getFieldValue(`class_id`) && classSubjects.length < 1"
          :loading="loading"
          @click="handleSubmit"
          >Setup Exam</a-button
        >
      </template>

      <a-form :form="form">
        <div class="row mb-0">
          <!-- Select Session -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Session">
              <a-select
                v-decorator="[
                  'session_id',
                  {
                    rules: [
                      { required: true, message: 'Please select a session!!' },
                    ],
                    initialValue: currentSession ? currentSession.id : '',
                  },
                ]"
                placeholder="Select session"
                :disabled="true"
              >
                <a-select-option
                  v-for="schoolSession in schoolSessions"
                  :value="schoolSession.id"
                  :key="schoolSession.id"
                >
                  {{ schoolSession.name }}
                  <small class="text-primary ml-3">{{
                    currentSession.id === schoolSession.id ? "Current" : ""
                  }}</small>
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- Select Class -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Class">
              <a-spin :spinning="classSpinning">
                <a-select
                  v-decorator="[
                    'class_id',
                    {
                      rules: [
                        { required: true, message: 'Please select a class!!' },
                      ],
                      initialValue: undefined,
                    },
                  ]"
                  placeholder="Select class"
                  @change="handleClassSelect"
                >
                  <a-select-option :value="undefined">
                    Select class
                  </a-select-option>
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option
                      :value="schoolClass.id"
                      :key="schoolClass.id"
                    >
                      {{ schoolClass.name }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>
          <!-- Select Section -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Sections">
              <a-spin :spinning="sectionSpinning">
                <a-checkbox-group
                  v-decorator="[
                    'sections',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a section!!',
                        },
                      ],
                      initialValue: [0],
                    },
                  ]"
                  @change="handleSectionAllSelect"
                >
                  <a-checkbox
                    :value="0"
                    :disabled="!form.getFieldValue('class_id')"
                  >
                    All
                  </a-checkbox>
                  <template class="col-4" v-for="section in sections">
                    <a-checkbox
                      :value="section.id"
                      :key="section.id"
                      :disabled="isAllSections"
                    >
                      {{ section.name }}
                    </a-checkbox>
                  </template>
                </a-checkbox-group>
              </a-spin>
            </a-form-item>
          </div>
           <!-- Enabled Common F.M. and P.M. checkbox-->
          <div class="col-md-3 mb-2">
            <a-form-item label="Take Common F.M. and P.M.">
              <!-- <a-checkbox @change="onEnabledChange">
                {{ enabled_status }}
              </a-checkbox> -->
              <a-checkbox
                v-decorator="[
                  'common_fm_pm',
                  {
                    valuePropName: 'checked',
                    initialValue: false,
                  },
                ]"
                @change="resetMark"
              >
                {{
                  form.getFieldValue("common_fm_pm") ? "Enabled" : "Disabled"
                }}
              </a-checkbox>
            </a-form-item>
          </div>

          <!-- Select Exam -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Select Exam">
              <a-select
                v-decorator="[
                  'exam_id',
                  {
                    rules: [
                      { required: true, message: 'Please select an exam!!' },
                    ],
                  },
                ]"
                placeholder="Select Exam"
              >
                <a-select-option
                  v-for="schoolExam in schoolExams"
                  :value="schoolExam.id"
                  :key="schoolExam.id"
                >
                  {{ schoolExam.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- Exam setting -->
          <div class="col-md-3 mb-2">
            <a-form-item label=" Select Exam Setting">
              <a-select
                v-decorator="[
                  'exam_setting_id']"
                placeholder="Select Exam Setting"
              >
                <a-select-option
                  v-for="Examsetting in examsettingdata"
                  :value="Examsetting.id"
                  :key="Examsetting.id"
                >
                  {{ Examsetting.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- Select is grades enabled -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Enable grades">
              <a-radio-group
                v-decorator="[
                  'grades',
                  {
                    rules: [
                      { required: true, message: 'This value is required' },
                    ],
                    initialValue: 0,
                  },
                ]"

              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <!-- full mark -->
          <div class="col-md-3 mb-2"

            id="common_mark_container"
          >
              <a-form-item label="Full Marks :">
                <a-input-number
                  v-decorator="[
                    'full_mark',
                    {
                      rules: [
                        { required: false, message: 'Please enter Full Mark!!' },
                      ],
                      initialValue: f_mark,
                    },
                  ]"
                  placeholder="Full Mark"
                  style="width: 200px"
                  :disabled="!form.getFieldValue('common_fm_pm')"
                />
              </a-form-item>
          </div>

          <!-- Marksheet Template  -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Marksheet/Report Card Template">
              <a-spin :spinning="marksheetTemplateSpinning">
                <a-select
                  size="large"
                  v-decorator="[
                    'marksheet_template_id',
                    {
                      rules: [{required: false,message: 'Please select a template!!',},],
                    },
                  ]"
                  placeholder="Select Template"
                  optionFilterProp="children"
                  style="width: 100%"
                  :filterOption="false"
                  :defaultValue="undefined"
                >
                  <a-select-option :value="undefined">Select Template</a-select-option>
                  <template v-for="marksheetTemplate in markSheetTemplates">
                    <a-select-option :value="marksheetTemplate.id" :key="marksheetTemplate.id">
                      {{marksheetTemplate.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

          <!-- Declare_all_section -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Declare All Section">
              <a-radio-group
                v-decorator="[
                  'declare_all_section',
                  {
                    rules: [
                      { required: true, message: 'This value is required' },
                    ],
                    initialValue: 0,
                  },
                ]"
              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>

          <div class="col-md-3 mb-2"></div>
          <!-- pass mark -->
          <div class="col-md-3 mb-2"
            id="common_mark_container"
          >
              <a-form-item label="Pass Marks :">
                <a-input-number
                  v-decorator="[
                    'pass_mark',
                    {
                      rules: [
                        { required: false, message: 'Please enter Pass Mark!!' },
                      ],
                      initialValue: p_mark,
                    },
                  ]"

                  placeholder="Pass Mark"
                  style="width: 200px"
                  :disabled="!form.getFieldValue('common_fm_pm')"
                />
              </a-form-item>
          </div>

          <!-- Attendance Period -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Attendance Period"
            help="Select the date range considered for attendance in this exam.">
              <a-range-picker
                v-decorator="[
                'attendance_period',
                  {
                    rules: [{ required: false, message: 'Please select attendance period!' }],
                  },
                ]"
              size="large"
              style="width: 100%"
              :format="dateFormat"
              :placeholder="['Start Date', 'End Date']"
              @change="handleAttendanceDateSelect"
              />
            </a-form-item>
          </div>
            <!-- Fees Control -->
          <div class="col-md-4 mb-2">
            <a-form-item
              label="Fees"
              help="Select the fee(s) that students must clear to be eligible for result declaration."
              >
            <a-select
              v-decorator="[
              'required_fee_ids',
              {
              rules: [{ required: false }],
              initialValue: [],
              },
            ]"
              mode="multiple"
              placeholder="Select fees"
              :loading="feesLoading"
              allowClear
              optionFilterProp="children"
              style="width: 100%"
              >
            <a-select-option
              v-for="fee in fees"
              :key="fee.id"
              :value="fee.id"
            >
              {{ fee.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>

          <div class="col-md-12" v-if="classSubjects.length > 0">
            <a-divider />
            <p class="font-weight-bold mt-3">Setup Exam Subjects</p>
            <a-spin :spinning="sectionSpinning">
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th></th>
                      <th>#</th>
                      <th>Subject</th>
                      <th>Full Mark</th>
                      <th>Pass Mark</th>
                      <th>Theory FM</th>
                      <th>Theory PM</th>
                      <th>Prac. FM</th>
                      <th>Prac. PM</th>
                      <th>Exam Date</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                  <th>Grades only</th>
                      <th>Practical</th>
                      <th>Oral</th>
                      <th>No exam</th>
                      <th>In total</th>
                      <th>Composite</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="subject in classSubjects" :key="subject.id">
                      <th
                        style="min-width: 30px; vertical-align: middle"
                        class="text-center"
                      >
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][selected]`,
                              { valuePropName: 'checked', initialValue: false },
                            ]"
                            @change="
                              toggleSubjectSelect($event, subject.subject_id)
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </th>
                      <td style="min-width:80px;">
                        <a-form-item>
                          <a-input-number
                            placeholder=""
                            v-decorator="[`subjects[${subject.subject_id}][sort_order_no]`, {rules: [{ required: form.getFieldValue(`subjects[${subject.subject_id}][selected]`), message: 'Required' }] }]"
                            :min="0"
                            :disabled="!form.getFieldValue(`subjects[${subject.subject_id}][selected]`)"
                            style="width: 100%;"
                          />
                        </a-form-item>
                      </td>
                      <td
                        style="
                          min-width: 150px;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                      >
                        {{ subject.subject.name }}
                        <a-form-item class="d-none">
                          <a-input
                            v-decorator="[
                              `subjects[${subject.subject_id}][subject_id]`,
                              {
                                rules: [
                                  { required: true, message: 'Required' },
                                ],
                                initialValue: subject.subject_id,
                              },
                            ]"
                          />
                        </a-form-item>
                      </td>
                      <td style="max-width: 100px">
                        <a-form-item>
                          <a-input
                            placeholder=""

                            v-decorator="[

                              `subjects[${subject.subject_id}][full_mark]`,

                              {
                                initialValue: form.getFieldValue(`subjects[${subject.subject_id}][grades_only]`) == true ? null : form.getFieldValue('full_mark'),
                              },
                            ]"
                            :min="0"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) || form.getFieldValue('common_fm_pm')
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="max-width: 100px">
                        <a-form-item>
                          <a-input
                            placeholder=""

                            v-decorator="[
                              `subjects[${subject.subject_id}][pass_mark]`,
                              {
                                initialValue: form.getFieldValue(`subjects[${subject.subject_id}][grades_only]`) == true ? null : form.getFieldValue('pass_mark'),
                              },
                            ]"
                            :min="0"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) || form.getFieldValue('common_fm_pm')
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="max-width: 100px">
                        <a-form-item>
                          <a-input
                            placeholder=""

                            v-decorator="[

                              `subjects[${subject.subject_id}][theory_full_mark]`,

                              {
                                initialValue: form.getFieldValue(`subjects[${subject.subject_id}][grades_only]`) == true ? null : form.getFieldValue('full_mark'),
                              },
                            ]"
                            :min="0"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) || form.getFieldValue('common_fm_pm')
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="max-width: 100px">
                        <a-form-item>
                          <a-input
                            placeholder=""

                            v-decorator="[
                              `subjects[${subject.subject_id}][theory_pass_mark]`,
                              {
                                initialValue: form.getFieldValue(`subjects[${subject.subject_id}][grades_only]`) == true ? null : form.getFieldValue('pass_mark'),
                              },
                            ]"
                            :min="0"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) || form.getFieldValue('common_fm_pm')
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="max-width: 100px">
                        <a-form-item>
                          <a-input
                            placeholder=""

                            v-decorator="[

                              `subjects[${subject.subject_id}][practical_full_mark]`,

                              {
                                initialValue: form.getFieldValue(`subjects[${subject.subject_id}][grades_only]`) == true ? null : form.getFieldValue('full_mark'),
                              },
                            ]"
                            :min="0"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) || form.getFieldValue('common_fm_pm')
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="max-width: 100px">
                        <a-form-item>
                          <a-input
                            placeholder=""

                            v-decorator="[
                              `subjects[${subject.subject_id}][practical_pass_mark]`,
                              {
                                initialValue: form.getFieldValue(`subjects[${subject.subject_id}][grades_only]`) == true ? null : form.getFieldValue('pass_mark'),
                              },
                            ]"
                            :min="0"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) || form.getFieldValue('common_fm_pm')
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="min-width: 130px">
                        <a-form-item>
                          <a-date-picker
                            :disabledDate=false
                            v-decorator="[
                              `subjects[${subject.subject_id}][date]`,
                              {
                                rules: [
                                  {
                                    required: form.getFieldValue(
                                      `subjects[${subject.subject_id}][selected]`
                                    ),
                                    message: 'Please input a start date',
                                  },
                                ],
                                initialValue: moment(),
                              },
                            ]"
                            :format="dateFormat"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="min-width: 130px">
                        <a-form-item>
                          <a-time-picker
                            v-decorator="[
                              `subjects[${subject.subject_id}][start_time]`,
                              {
                                rules: [
                                  {
                                    required: form.getFieldValue(
                                      `subjects[${subject.subject_id}][selected]`
                                    ),
                                    message: 'Please input an start time',
                                  },
                                ],
                                initialValue: moment(),
                              },
                            ]"
                            use12Hours
                            :format="timeFormat"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                            style="width: 100%"
                          >
                          </a-time-picker>
                        </a-form-item>
                      </td>
                      <td style="min-width: 130px">
                        <a-form-item>
                          <a-time-picker
                            v-decorator="[
                              `subjects[${subject.subject_id}][end_time]`,
                              {
                                rules: [
                                  {
                                    required: form.getFieldValue(
                                      `subjects[${subject.subject_id}][selected]`
                                    ),
                                    message: 'Please input an end time',
                                  },
                                ],
                                initialValue: moment(),
                              },
                            ]"
                            use12Hours
                            :format="timeFormat"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                            style="width: 100%"
                          >
                          </a-time-picker>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][grades_only]`,
                              { valuePropName: 'checked', initialValue: false },
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                              form.getFieldValue(
                                `subjects[${subject.subject_id}][is_in_total]`
                              )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][has_practical]`,
                              { valuePropName: 'checked', initialValue: false },
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][is_oral]`,
                              { valuePropName: 'checked', initialValue: false },
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][has_exam]`,
                              { valuePropName: 'checked', initialValue: false },
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][is_in_total]`,
                              { valuePropName: 'checked', initialValue: false },
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                              form.getFieldValue(
                                `subjects[${subject.subject_id}][grades_only]`
                              )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][is_composite]`,
                              { valuePropName: 'checked', initialValue: false },
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </a-spin>
          </div>

          <div
            v-if="form.getFieldValue(`class_id`) && classSubjects.length < 1"
            class="col-md-12 py-2"
          >
            <h5 class="text-danger">Cannot Setup Exam!</h5>
            <strong class="text-danger"
              >No subjects found for this class! Please check the class setup
              for the selected class to add subjects.</strong
            >
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'

export default {
  name: 'AddExamSetup',
  mounted: function () {
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
        this.getExamsSetting()
        this.getMarksheetTemplates()
      })
      .catch((error) => {
        console.log(error)
      })
    this.getFees()
    this.getExams()
    this.resetMark()
  },
  computed: {
    currentSession: function () {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
    isAllSections: function (val) {
      if (val) {
        this.form.setFieldsValue({ sections: [0] })
      }
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      examLoading: false,
      schoolExams: [],
      schoolClasses: [],
      sections: [],
      fees: [],
      feesLoading: false,
      schoolSessions: [],
      classSubjects: [],
      selectedSession: undefined,
      isAllSections: true,
      classSpinning: false,
      sectionSpinning: false,
      subjectSpinning: false,
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'h:mm a',
      showMarkField: false,
      enabled_status: 'Disabled',
      f_mark: '',
      p_mark: '',
      show_columns: true,
      examsettingdata: [],
      changeData: '',
      markSheetTemplates: [],
      marksheetTemplateSpinning: false,
    }
  },
  methods: {
    moment,
    resetMark(e) {
      if (!e.target.checked) {
        this.form.setFieldsValue({ full_mark: '' })
        this.form.setFieldsValue({ pass_mark: '' })
        // return this.f_mark = '',this.p_mark = ''
      }
    },
    showModal() {
      this.visible = true
    },
    getExams() {
      this.examLoading = true
      this.$http
        .get('/api/exam', {
          params: {
            limit: 15,
          },
        })
        .then(({ data }) => {
          this.examLoading = false
          this.schoolExams = data.data
        })
    },
    getExamsSetting: function () {
      // this.classSpinning = true;
      this.$http
        .get('/api/exam/settings/all', {
          session_id: this.selectedSession,
        })
        .then(({ data }) => {
          // console.warn(data.data)
          this.examsettingdata = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getFees: function() {
      this.feesLoading = true
      this.$http
        .get('/api/fee')
        .then(({ data }) => {
          this.fees = data.data
          this.feesLoading = false
        })
        .catch(() => {
          this.feesLoading = false
        })
    },
    getMarksheetTemplates: function () {
      this.marksheetTemplateSpinning = true
      this.$http.get('/api/exam/marksheet/templates', {
        session_id: this.selectedSession,
      })
        .then(({ data }) => {
          this.markSheetTemplates = data.data
          this.marksheetTemplateSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClassSubjects(classId) {
      this.$http
        .get(`/api/subject/class/${classId}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.classSubjects = data.data.all
          this.subjectSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getClasses: function () {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['sections'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
        this.getClassSubjects(value)
      }
    },
    getClassSections(value) {
      this.$http
        .get(`/api/section/class/${value}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleSectionAllSelect(value) {
      if (value.includes(0)) {
        this.isAllSections = true
      } else {
        this.isAllSections = false
      }
    },
    toggleSubjectSelect(e, subjectId) {
      if (!e.target.checked) {
        this.form.resetFields([
          `subjects[${subjectId}][full_mark]`,
          `subjects[${subjectId}][pass_mark]`,
          `subjects[${subjectId}][theory_full_mark]`,
          `subjects[${subjectId}][theory_pass_mark]`,
          `subjects[${subjectId}][practical_full_mark]`,
          `subjects[${subjectId}][practical_pass_mark]`,
          `subjects[${subjectId}][date]`,
          `subjects[${subjectId}][start_time]`,
          `subjects[${subjectId}][end_time]`,
          `subjects[${subjectId}][grades_only]`,
          `subjects[${subjectId}][has_practical]`,
          `subjects[${subjectId}][is_oral]`,
          `subjects[${subjectId}][has_exam]`,
          `subjects[${subjectId}][is_in_total]`,
          `subjects[${subjectId}][is_composite]`,
        ])
      }
    },
    handleAttendanceDateSelect(dates) {
      if (dates && dates.length === 2) {
        const [start, end] = dates
        this.form.setFieldsValue({
          attendance_from_date: start.format('YYYY-MM-DD'),
          attendance_to_date: end.format('YYYY-MM-DD'),
        })
      } else {
        this.form.setFieldsValue({
          attendance_from_date: null,
          attendance_to_date: null,
        })
      }
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.attendance_period && values.attendance_period.length === 2) {
            values.attendance_from_date = values.attendance_period[0].format('YYYY-MM-DD')
            values.attendance_to_date = values.attendance_period[1].format('YYYY-MM-DD')
          }

          // Optional: remove the combined field before sending
          delete values.attendance_period

          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to setup class exam!`,
            onOk: () => {
              const formData = this.makeFormData(values)
              // console.log(formData);
              this.$http
                .post('/api/classsectionexam', {
                  class_id: formData.class_id,
                  declare_all_section: formData.declare_all_section,
                  exam_id: formData.exam_id,
                  exam_setting_id: formData.exam_setting_id,
                  grades: formData.grades,
                  is_all_section: formData.is_all_section,
                  sections: formData.sections,
                  session_id: formData.session_id,
                  subjects: formData.subjects,
                  certificate_template_id: formData.marksheet_template_id,
                  required_fee_ids: formData.required_fee_ids,
                  attendance_from_date: formData.attendance_from_date,
                  attendance_to_date: formData.attendance_to_date,
                })
              // this.$http
              //   .post("/api/classsectionexam", formData)
                .then(({ data }) => {
                  // console.log(data.data)
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Setup successful!',
                    description: `Exam has been successfully setup!`,
                  })
                  this.form.resetFields()
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
    disabledDate(current) {
      // Can not select days before today
      return current < moment().startOf('day')
    },
    makeFormData(values) {
      const subjects = values.subjects
        .filter((element) => {
          return element.selected
        })
        .map((element) => {
          delete element['selected']

          element.date = moment(element.date).format('YYYY-MM-DD')

          element.start_time = moment(element.start_time).format('HH:mm:ss')
          element.end_time = moment(element.end_time).format('HH:mm:ss')

          element.grades_only = element.grades_only ? 1 : 0
          element.has_practical = element.has_practical ? 1 : 0
          element.is_oral = element.is_oral ? 1 : 0
          element.has_exam = element.has_exam ? 0 : 1
          element.is_in_total = element.is_in_total ? 1 : 0
          element.is_composite = element.is_composite ? 1 : 0

          return element
        })

      values.is_all_section = 0

      if (values.sections.includes(0)) {
        values.sections = this.sections.map((element) => {
          return element.id
        })
        values.is_all_section = 1
      }

      values.subjects = subjects
      return values
    },
  },
}
</script>
<style scoped>
#common_mark_container {
  display: flex;
  /* justify-content: center; */
}
.PM_content {
  margin-left: 65px;
  width: 400px;
}
</style>
